var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 8.725C18 4 13.972.173 9 .173S0 4.001 0 8.725c0 4.268 3.291 7.806 7.594 8.448v-5.976H5.307V8.725h2.287V6.84c0-2.144 1.342-3.327 3.4-3.327.984 0 2.014.167 2.014.167v2.103h-1.135c-1.118 0-1.467.66-1.467 1.336v1.605h2.496l-.399 2.472h-2.097v5.976C14.71 16.531 18 12.993 18 8.725"
  })));
};
export default SvgFacebook;